import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vimeo',
  templateUrl: './vimeo.component.html',
  styleUrls: ['./vimeo.component.scss']
})
export class VimeoComponent implements OnInit {
  constructor() {}

  public ngOnInit(): void {}
}
